import axios from '../axios'

export const age = (data) => {
    return axios({
        url: '/admin/service/person_age_counting',
        method: 'post',
        data
    })
}
export const gender = (data) => {
    return axios({
        url: '/admin/service/people_gender_counting',
        method: 'post',
        data
    })
}

export const people_type = (data) => {
    return axios({
        url: '/admin/service/people_type_counting',
        method: 'post',
        data
    })
}
// get_buildings_num
export const buildings_num = (data) => {
    return axios({
        url: '/admin/service/get_buildings_num',
        method: 'post',
        data
    })
}
// /get_house_type
export const house_type = (data) => {
    return axios({
        url: '/admin/service/get_house_type',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataScreen.js